import { useEffect } from "react";
import { useDataCache } from "@newageerp/v3.app.data-cache-provider";
import { useSelector } from "@newageerp/v3.templates.templates-core";
import { SelectorSystemRunNae } from "../models/ormSelectors";

interface ChildId {
  id: number
}

export interface ISystemRunModelNae {
    _viewTitle: string,
      id: number,
      scopes: any,
      badges: any,
  }

export const ISystemRunFieldsNae = [
    "_viewTitle",
    "id",
    "scopes",
    "badges"
];

export function useSystemRunHookNae(id: number) : ISystemRunModelNae {
  // @ts-ignore
  const element = useSelector((state) => SelectorSystemRunNae(state, id));

  const { addToQueue } = useDataCache();

  useEffect(() => {
    if (!element) {
      addToQueue({
        elementId: id,
        schema: "system-run",
        fields: ISystemRunFieldsNae,
      });
    }
  }, [element, id]);

  return element;
}
